const modalCreateNote = {
  header: 'Crear nota',
  btnCancel: 'Cancelar',
  btnOk: 'Ok',
};

export default modalCreateNote;
